import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { headers } from '../apiConfig'; // ✅ кастомные заголовки от тебя
import { getServerUrl } from '../../Utils/serverSelector';

const initialState = {
  status: 'idle',
  error: null,
  successMessage: '',
};

// ✅ AsyncThunk с headers
export const sendContactMessage = createAsyncThunk(
  'contact/sendContactMessage',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${getServerUrl()}/contact-us`,
        formData,
        { headers } // ✅ сюда вставляем headers
      );
      return res.data.message; // например, "Сообщение успешно отправлено!"
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Ошибка отправки сообщения');
    }
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    resetContactState: (state) => {
      state.status = 'idle';
      state.error = null;
      state.successMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendContactMessage.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.successMessage = '';
      })
      .addCase(sendContactMessage.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.successMessage = action.payload; // message from backend
      })
      .addCase(sendContactMessage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = contactSlice.actions;

export default contactSlice.reducer;
